import { render, staticRenderFns } from "./fiber.vue?vue&type=template&id=0c93a545&scoped=true"
import script from "./fiber.vue?vue&type=script&lang=js"
export * from "./fiber.vue?vue&type=script&lang=js"
import style0 from "./fiber.vue?vue&type=style&index=0&id=0c93a545&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c93a545",
  null
  
)

export default component.exports